var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{key:_vm.keyName,class:_vm.className,attrs:{"url":_vm.interfaceUrl,"downloadPath":_vm.downloadPath},on:{"click":function($event){return _vm.xhrDownloadFile()}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f58eb6d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadButton.vue
// module id = V6e/
// module chunks = 83